$(function() {
  // Setup mailchimp subscription form as ajax
  $('form.email-subscribe').bind('submit', function (event) {
    if (event) event.preventDefault()

    var $form = $(event.target),
      $submitButton = $form.find('button[type=submit]')

    $form.removeClass('form-error', 'form-success')
    $submitButton.data('originalText', $submitButton.text())
    $submitButton.text('Sending...')

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      error: function (err) { alert('Something went wrong. Please try again later.') },
      success: function (data) {
        $submitButton.text($submitButton.data('originalText'))

        if (data.result === 'success') {
          // Yeahhhh Success
          console.log(data.msg)
          $form.addClass('form-success')
          $form.find('input').val('').blur()
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg)
          $form.find('.form-message-error').html(data.msg)
          $form.addClass('form-error')
          // alert('Something went wrong. Please try again later.')
        }
      }
    })
  })
})
